import React, { useState } from "react";
import { Menu } from "antd";
//import {Link} from "react-router-dom";
// import _ from 'lodash';
import SidebarLogo from "./SidebarLogo";



import { Link, useLocation } from "react-router-dom";
import MenuList from './Menu'
const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;


const SidebarContent = () => {

  const location = useLocation();

  // const logInUser = useSelector(state => state.auth.authUser);
  const logInUser = JSON.parse(localStorage.getItem('userInfo'))
  console.log("========= logInUser ========",logInUser);
  // const messageProps = useSelector(state => state.MessagesR);
  const role = logInUser && logInUser.role;
  console.log("========= role ========",role);
  
  const MenuData = MenuList[role];
  const [changeSelectedKey, setSelectedKey] = useState('');
  //const [selectedUrl, setSelectedUrl] = useState(location && location.pathname);
  const { showNotificationBadge } = []

  const renderBadge = () => {
    if (showNotificationBadge && showNotificationBadge.length) {
      return <span className="gx-bg-primary gx-rounded-circle gx-badge gx-text-white">{showNotificationBadge.length}</span>
    }
  }

  const singleMenuItem = (Item) => {

    return <Menu.Item key={Item.url} >
      <Link to={{ pathname: Item.url, state: { key: Item.key } }} key={Item.url + "key"}>
        <i className={`icon icon-${Item.icon}`} style={{
          top: Item.top,
          position: 'relative'
        }} />
        <span>{Item.title} {Item.badges ? renderBadge() : ""}</span>
      </Link>
    </Menu.Item>
  }


  const renderSubMenu = (Item) => {
    return <SubMenu key={Item.title}
      onTitleClick={() => {
        console.log("======== Item ======", Item);
        setSelectedKey(Item.title);
      }}
      title={<span> <i className={`icon icon-${Item.icon}`} />
        <span>{Item.title}</span></span>}>
      {Item.subMenu.map(x => {
        return singleMenuItem(x)
      })}
    </SubMenu>
  }


  // const getPermission = (userInfo) => {
  //   const Result = [];
  //   const permission = userInfo.permission;
  //   let permissionOnly = _.omitBy(permission, v => (_.isBoolean(v) || _.isFinite(v)) ? false : _.isEmpty(v))
  //   const allKeys = _.keys(permissionOnly);
  //   let notData = ["_id", "createdAt", "roleName", "__v", "roleColor", "userCount", "createdBy", "roleType"];
  //   allKeys.map(Item => {
  //     if (!notData.includes(Item)) {
  //       Result.push(Item);
  //     }
  //     return Item
  //   })
  //   return Result;
  // }

  const renderMenu = () => {

    // const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (MenuData) {
      return MenuData.map(Item => {
        if (Item.subMenu) {
          return (
            renderSubMenu(Item)
          )
        } else {
          return singleMenuItem(Item)
        }
      })
    }
  }



  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">

        <div className="gx-layout-sider-scrollbar gx-mt-4">
          <Menu
            defaultOpenKeys={location.state && location.state.key}
            defaultSelectedKeys={[location.pathname]}
            selectedKeys={[location.pathname]}
            openKeys={[changeSelectedKey, location.state && location.state.key]}
            theme='dark'
            mode="inline">
            {renderMenu()}
            <span className="version-number">collab-care version 1.0</span>
          </Menu>
        </div>
      </div>
    </>
  );
};

SidebarContent.propTypes = {};
export default SidebarContent;

